import React, { useState, useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './assessment-invitation-modal.styles'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import EmailInput from 'pobble-components/dist/email-input'
import { ColorsInfo } from 'pobble-components/dist/email-input/utils'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import InfoMessage from './info-message/info-message.container'
import { useRecaptcha } from 'pobble-components/dist/recaptcha'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import FormRow from 'pobble-components/dist/form-elements/form-row'

const AssessmentInvitationModal = ({
  classes,
  isOpen,
  onSubmit,
  requestClose,
  pending,
  id
}) => {
  const [selectedEmails, setSelectedEmails] = useState([])
  const [message, setMessage] = useState('')

  const {
    Recaptcha,
    recaptchaProps,
    recaptchaPending,
    getReCaptchaToken
  } = useRecaptcha()

  pending = pending || recaptchaPending

  useEffect(() => {
    // Clear selected emails each time user opens modal
    isOpen && setSelectedEmails([])
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} closeButton requestClose={requestClose}>
      <ModalHeader>Invite contributors</ModalHeader>
      <ModalContent>
        <FormRow>
          <FormLabel spaceBetween small>
            To: {!!selectedEmails.length && <ColorsInfo />}
          </FormLabel>
          <EmailInput
            cacheKey="moderationInvitationEmailCache"
            selected={selectedEmails}
            onChange={setSelectedEmails}
          />
        </FormRow>
        <FormRow>
          <FormLabel spaceBetween small>
            Message (optional) <CharactersCount value={message} max={400} />
          </FormLabel>
          <FormTextArea
            maxLength={400}
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </FormRow>
        <InfoMessage id={id} />
        <Recaptcha {...recaptchaProps} />
      </ModalContent>
      <ModalFooter alignRight>
        <Button
          pending={pending}
          disabled={!selectedEmails.length}
          action={() =>
            getReCaptchaToken(token => onSubmit(selectedEmails, token, message))
          }
          tall>
          {!pending &&
            `Send ${
              selectedEmails.length > 1 ? `${selectedEmails.length} ` : ''
            }invitation${selectedEmails.length > 1 ? 's' : ''}`}
          {pending && 'Sending...'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default injectSheet(styles)(AssessmentInvitationModal)
